module.exports = __webpack_public_path__ + "img/service-providers-icon.11666649.png";